import { type ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { TableWithSearch } from "@/components";
import type { DataTableFeatures } from "@/components/data-table/features";
import { useBreadCrumbContext } from "@/contexts/breadcrumb";
import { useCurrentStore, useInventories } from "../../hooks";

const Inventories = () => {
	const { t } = useTranslation();
	useBreadCrumbContext([{ label: t("inventories.pageTitle") }]);
	const currentStore = useCurrentStore();
	const [page, setPage] = useState(1);

	const { data, isLoading } = useInventories({
		"q[storeIdEq]": currentStore?.id,
	});

	const columnHelper = createColumnHelper<DataTableFeatures, Inventory>();

	const columns = useMemo(
		() =>
			[
				columnHelper.accessor("createdAt", {
					header: t("inventories.table.createdAt"),
					cell: (props) => (
						<Link
							className="underline"
							to={`/inventories/${props.row.original.id}`}
						>
							{props.getValue()}
						</Link>
					),
				}),
				columnHelper.accessor("status", {
					header: t("inventories.table.status"),
				}),
			] as ColumnDef<DataTableFeatures, Inventory>[],
		[columnHelper, t],
	);

	return (
		<TableWithSearch
			searchPlaceholder={t("inventories.searchPlaceholder")}
			isLoading={isLoading}
			columns={columns}
			data={data?.data}
			currentPage={page}
			totalPages={data?.headers["total-pages"]}
			onPageChange={setPage}
		/>
	);
};

export default Inventories;
